export default "## Terms of Use\n\n[Add your individual terms here...]"